import Logo from '@assets/st-logo-2022.svg';
import { BodyText, Stack, StackItem } from '@servicetitan/design-system';
import styled from 'styled-components';

export const SigninPageContainer = styled(Stack)``;

export const SigninPageContent = styled(StackItem)`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 2;
  height: 100vh;
  justify-content: center;
  position: relative;
`;

export const STLogo = styled(Logo)`
  left: 24px;
  position: absolute;
  top: 24px;
`;

export const WelcomeContainer = styled(Stack)`
  width: 320px;
`;

export const NoWrapText = styled(BodyText)`
  white-space: nowrap;
`;

export const SidebarContainer = styled(StackItem)`
  flex: 1;
  max-width: fit-content;
  overflow: hidden;

  @media (max-width: 1024px) {
    display: none;
  }
`;
